/* unplugin-vue-components disabled */import script from "./permission.vue?vue&type=script&setup=true&lang=ts"
export * from "./permission.vue?vue&type=script&setup=true&lang=ts"

import "./permission.vue?vue&type=style&index=0&id=05279a66&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05279a66"]])

export default __exports__